import { gql } from "@apollo/client";

export const MEMBER_BASIC_DETAILS = gql`
  fragment MemberBasicDetails on MemberType {
    objectId
    expiryDate
    balance
    user {
      objectId
      name
      email
      phone
      devices {
        edges {
          node {
            deviceInfo
          }
        }
      }
      lastActiveOn
      dateOfBirth
      isActive
      dateJoined
      createdOn
      photo
    }
  }
`;
